import styled from "styled-components";

import BadgeSmallMonza from "components/UI/Badge/Small/Monza";
import WidgetBox from "components/UI/WidgetBox";
import Dialog from "components/UI/Dialog";

export const Badge = styled(BadgeSmallMonza).attrs({
  className: "notif-badge"
})`
  &.notif-badge {
    font-size: 10px;
    height: 14px;
    top: -7px;
    width: 14px;
  }
`;

export const IconContainer = styled.span.attrs({ className: "notif-icon" })`
  cursor: pointer;
  height: 16px;
  position: relative;
  user-select: none;
`;

export const NotificationBox = styled(WidgetBox).attrs({
  className: "notif-tray"
})`
  & .notif-list {
    height: 425px;
    overflow-y: scroll;
  }
  & .notification {
    cursor: pointer;
    display: flex;
    flex-direction: row;
    font-weight: bold;
    height: auto;
    line-height: 22px;
    height: 52px;
    max-height: 52px;
    overflow: hidden;
    padding: 15px;
    position: relative;
    text-overflow: ellipsis;
    transition: max-height 0.5s;
    white-space: nowrap;
  }
  & .notification:hover {
    color: initial;
  }
  & .notification.active {
    color: initial;
    height: auto;
    max-height: 500px;
    white-space: normal;
  }
  & .notification.active .content {
    max-height: unset;
  }
  & .notification.read {
    font-weight: normal;
  }

  & .content {
    flex: 1;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    max-height: 1.2rem;
  }

  & .timestamp {
    color: ${props => props.theme.colors.makoLighter};
    font-size: 11px;
    font-weight: normal;
    padding: 13px 0;
  }
`;

export const StyledDialog = styled(Dialog).attrs({ className: "notif-dialog" })`
  background: ${props => props.theme.colors.white};
  top: 48px;
  width: 350px;
`;

export const ViewAllDiv = styled.div`
  align-items: center;
  background: ${props => props.theme.colors.silver};
  display: flex;
  height: 30px;
  justify-content: center;
`;
